const urlBook = lang => `https://book.mydrsmile.com/${lang}/auth/password/forgot`;

const urlForgotPassword = {
  'de-DE': urlBook('de-DE'),
  'de-AT': urlBook('de-AT'),
  'pt-PT': urlBook('pt-PT'),
  es: urlBook('es-ES'),
  fr: urlBook('fr-FR'),
  it: urlBook('it-IT'),
  se: urlBook('sv-SE'),
  nl: urlBook('nl-NL'),
};

module.exports = urlForgotPassword;
